import React from 'react'
import updateSelectedUseItWithVariantIdProductAction from 'modules/product/redux/actions/update-selected-perfect-your-look-variant-id'
import useDispatch from 'hooks/use-dispatch'
import logEventWithPrefixAnalyticsUtil from 'utils/analytics/log-event-with-prefix'
import logUtil from 'utils/log'
import QuickShopProductSidebarColorSwatchesItem from 'containers/QuickShopProductSidebar/components/ColorSwatches/components/Item'

const ANALYTICS_EVENT = {
  SELECT_PERFECT_YOUR_LOOK_VARIANT: 'SELECT_PERFECT_YOUR_LOOK_VARIANT'
}

/**
 * @param props
 * @param {ProductVariantCollection} props.perfectYourLookVariantItem
 * @param {boolean} props.isSelected
 * @param {string} props.analyticEventPrefix
 * @returns {JSX.Element}
 * @constructor
 */
export default function QuickShopProductSidebarUseItWithProductSwatchPickerItem (props) {
  const {
    perfectYourLookVariantItem,
    isSelected,
    analyticEventPrefix
  } = props
  const dispatch = useDispatch()

  const logEvent = (event, data) => {
    return logEventWithPrefixAnalyticsUtil(analyticEventPrefix, event, data)
  }

  const handleClick = () => {
    logUtil('QuickShopProductSidebarUseItWithProductSwatchPickerItem#handleClick').debug('[start]')

    const variantId = perfectYourLookVariantItem.variant_id
    dispatch(
      updateSelectedUseItWithVariantIdProductAction(perfectYourLookVariantItem.variant_id)
    )

    logEvent(ANALYTICS_EVENT.SELECT_PERFECT_YOUR_LOOK_VARIANT, {
      variantId
    })
  }

  return (
    <QuickShopProductSidebarColorSwatchesItem
      isSelected={isSelected}
      productVariant={perfectYourLookVariantItem}
      onClick={handleClick}
    />
  )
}
